import Button from "../Button/Button.jsx";
import { Variants } from "../Button/Variants.jsx";

/**
 * Generates an array of confirmation and abort buttons.
 *
 * @param {Function} setOpen - Function to control the visibility of a modal or similar component. Called with `false` when the abort button is clicked.
 * @param {Function} handleConfirm - Function to handle the confirmation action when the confirm button is clicked.
 * @param {string} [confirmLabel="Entfernen"] - Optional label for the confirmation button. Defaults to "Entfernen".
 * @returns {Array} Array containing two button components: the abort button and the confirm button.
 */
export const getConfirmAbortButtons = (
  setOpen,
  handleConfirm,
  confirmLabel = "Entfernen",
) => [
  <Button
    variant={Variants.SECONDARY}
    onClick={() => {
      setOpen(false);
    }}
  >
    Abbrechen
  </Button>,
  <Button
    variant={Variants.PRIMARY}
    onClick={() => {
      handleConfirm();
      setOpen(false);
    }}
  >
    {confirmLabel}
  </Button>,
];
